/**
 * Pending (approval workflow) API service
 */
export class PendingApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Fetch moderation-queue sizes: per-entity counts plus a `total`.
   */
  getCounts() {
    return this.client.get('/pending/counts');
  }

  /**
   * Approve pending item
   */
  approveItem(itemId) {
    return this.client.put(`/pending/items/${itemId}`);
  }

  /**
   * Reject pending item
   */
  rejectItem(itemId, reason = null) {
    return this.client.delete(`/pending/items/${itemId}`, reason ? { reason } : null);
  }

  /**
   * Apply one verdict ('approve' | 'reject') to many pending items.
   */
  batchModerateItems(ids, verdict, reason = null) {
    return this.client.post('/pending/items/batch', { ids, verdict, reason });
  }

  /**
   * Approve pending author
   */
  approveAuthor(authorId) {
    return this.client.put(`/pending/authors/${authorId}`);
  }

  /**
   * Reject pending author
   */
  rejectAuthor(authorId, reason = null) {
    return this.client.delete(`/pending/authors/${authorId}`, reason ? { reason } : null);
  }

  /**
   * Apply one verdict ('approve' | 'reject') to many pending authors.
   * Resolves to `{ approved, rejected, failed }` — partial failures do not throw.
   */
  batchModerateAuthors(ids, verdict, reason = null) {
    return this.client.post('/pending/authors/batch', { ids, verdict, reason });
  }

  /**
   * Approve pending list
   */
  approveList(listId) {
    return this.client.put(`/pending/lists/${listId}`);
  }

  /**
   * Reject pending list
   */
  rejectList(listId, reason = null) {
    return this.client.delete(`/pending/lists/${listId}`, reason ? { reason } : null);
  }

  /**
   * Apply one verdict ('approve' | 'reject') to many pending lists.
   * Resolves to `{ approved, rejected, failed }` — partial failures do not throw.
   */
  batchModerateLists(ids, verdict, reason = null) {
    return this.client.post('/pending/lists/batch', { ids, verdict, reason });
  }

  /**
   * Approve pending site
   */
  approveSite(siteId) {
    return this.client.put(`/pending/sites/${siteId}`);
  }

  /**
   * Reject pending site.
   */
  rejectSite(siteId, reason = null) {
    return this.client.delete(`/pending/sites/${siteId}`, reason ? { reason } : null);
  }

  /**
   * Apply one verdict ('approve' | 'reject') to many pending sites.
   * Resolves to `{ approved, rejected, failed }` — partial failures do not throw.
   */
  batchModerateSites(ids, verdict, reason = null) {
    return this.client.post('/pending/sites/batch', { ids, verdict, reason });
  }
}

export default PendingApi;
